import React from 'react';
import {TextInput} from 'reactis-inputs';
import immutable from "immutable";

export default class FilterGroupsInput extends React.Component {

	static filterDelay = true;

  handleG1(val) {
    const value = this.props.value ? this.props.value.set('g1', val) : immutable.Map({g1: val, g2: null});
    this.props.onChange(value);
  }

  handleG2(val) {
    const value = this.props.value ? this.props.value.set('g2', val) : immutable.Map({g1: null, g2: val});
    this.props.onChange(value);
  }

	render() {

    const v1 = this.props.value && this.props.value.get('g1');
    const v2 = this.props.value && this.props.value.get('g2');

		return <div>
      <table>
        <tr>
          <td>I.</td>
          <td><TextInput {...this.props} value={v1} onChange={(value) => this.handleG1(value)} style={{width: 100, height:18, textOverflow: 'ellipsis'}} clearable={false} /></td>
        </tr>
        <tr>
          <td>II.</td>
          <td><TextInput {...this.props} value={v2} onChange={(value) => this.handleG2(value)} style={{width: 100, height:18, textOverflow: 'ellipsis'}} clearable={false} /></td>
        </tr>
      </table>

		</div>;
	}
}


// WEBPACK FOOTER //
// ./src/components/Form/FilterGroupsInput.js